<template>
  <template v-if="theme === 'theme2'">
    <button
      v-if="!isLink"
      data-w-id="bd454024-605c-912a-bc49-318b72174c6f"
      class="button form-field-wrapper n-cursor-pointer d-flex flex-column justify-content-center align-items-center px-4 tw-w-full"
      :style="classes"
      :type="type"
      :data-wait="dataWait"
      :value="value"
      @click="onClicked()"
    >
      <div class="button-label">
        <slot name="label">
          {{ label }}
        </slot>
      </div>
      <div style="height: 0%" class="overlay"></div>
    </button>
    <nuxt-link
      v-if="isLink"
      data-w-id="bd454024-605c-912a-bc49-318b72174c6f"
      class="button form-field-wrapper n-cursor-pointer d-flex flex-column justify-content-center align-items-center px-4"
      :style="classes"
      :href="link"
      :external="external"
    >
      <div class="button-label">
        <slot name="label">
          {{ label }}
        </slot>
      </div>
      <div style="height: 0%" class="overlay"></div>
    </nuxt-link>
  </template>
  <template v-else-if="theme === 'theme3'">
    <nuxt-link
      v-if="isLink"
      :to="link"
      :target="target"
      :external="true"
      class="pxp-search-properties-btn nc-button tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-items-center tw-justify-center"
      :style="classes"
      style="
        background-color: var(--nc-primary-button-bg-color);
        color: var(--nc-primary-button-text-color);
        border-radius: var(--nc-primary-button-radius) !important;
      "
    >
      <slot name="label">
        {{ label }}
      </slot>
    </nuxt-link>
    <button
      v-else-if="!isLink"
      class="pxp-search-properties-btn nc-button tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-items-center tw-justify-center"
      :style="classes"
      :type="type"
      :data-wait="dataWait"
      :value="value"
      style="
        background-color: var(--nc-primary-button-bg-color);
        color: var(--nc-primary-button-text-color);
        border-radius: var(--nc-primary-button-radius) !important;
      "
      @click="onClicked()"
    >
      <slot name="label">
        {{ label }}
      </slot>
    </button>
  </template>
  <template v-else>
    <button class="nc-button n-primary" :class="styleClass" :data-wait="dataWait" @click="onClicked()">
      <div class="button-label">
        <slot name="label">
          {{ label }}
        </slot>
      </div>
    </button>
  </template>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'NcButton',

  props: {
    label: {
      required: false,
      type: String,
    },

    isDisabled: {
      required: false,
      type: Boolean,
    },

    height: {
      required: false,
      type: Number,
      default: 60,
    },

    width: {
      required: false,
      type: Number,
      default: null,
    },

    isLink: {
      required: false,
      type: Boolean,
      default: false,
    },

    link: {
      required: false,
      type: String,
      default: '',
    },

    external: {
      required: false,
      type: Boolean,
      default: true,
    },

    dataWait: {
      required: false,
      type: String,
      default: null,
    },

    value: {
      required: false,
      type: String,
      default: null,
    },

    type: {
      required: false,
      type: String,
      default: null,
    },

    target: {
      required: false,
      type: String,
      default: null,
    },

    styleClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  emits: ['onClick'],

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    classes() {
      return `height: ${this.height}px; ${this.width ? `width: ${this.width}px !important;` : ''}`;
    },
  },

  methods: {
    onClicked() {
      if (!this.isDisabled) {
        this.$emit('onClick');
      }
    },
  },
});
</script>

<style scoped>
.button-label {
  font-weight: 300 !important;
}
</style>
